import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import MainDrawer from "components/drawer/MainDrawer";
import ApkUploadDrawer from "components/drawer/ApkUploadDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

const ApkWaiterTable = ({
  apkList = [],
  perpage = 10,
  currentPage = 1,
  hideDelete = false,
  hideEdit = false,
}) => {
  const { title, serviceId, handleUpdate, isSubmitting } = useToggleDrawer();

  // Calculate the slice of data for pagination
  const startIndex = (currentPage - 1) * perpage;
  const paginatedData = apkList.slice(startIndex, startIndex + perpage);

  return (
    <>
      <DeleteModal id={serviceId} title={title} />
      <MainDrawer>
        <ApkUploadDrawer id={serviceId} />
      </MainDrawer>
      <TableBody>
        {paginatedData.length > 0 ? (
          paginatedData.map((apk, index) => (
            <TableRow key={apk.id || `row-${index}`}>
              <TableCell className="text-center text-xs">
                {startIndex + index + 1}
              </TableCell>
              <TableCell className="text-center text-xs">
                {apk.name || "-"}
              </TableCell>
              <TableCell className="text-center text-xs">
                {apk.email || "-"}
              </TableCell>
              <TableCell className="text-center text-xs">
                {apk.mobile || "-"}
              </TableCell>
         <TableCell className="text-center text-xs">
  {apk.created_at
    ? new Date(apk.created_at).toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    : "-"}
</TableCell>
              {!(hideEdit && hideDelete) && (
                <TableCell>
                  <div className="flex justify-center">
                    <EditDeleteButton
                      id={apk.id}
                      title={apk.name || "Unnamed"}
                      isSubmitting={isSubmitting}
                      handleUpdate={() =>
                        handleUpdate(apk.id, null, null, apk.name || "Unnamed")
                      }
                      hideEdit={hideEdit}
                      hideDelete={hideDelete}
                    />
                  </div>
                </TableCell>
              )}
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={6} className="text-center text-sm text-gray-500">
              No data available
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  );
};

export default ApkWaiterTable;